var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.3541,
    height: 33.3541,
    rx: 16.6771,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6772 20.8965H13.3016C10.9147 20.8965 9.72131 20.8965 8.97979 20.155C8.23828 19.4135 8.23828 18.22 8.23828 15.8332V14.1454C8.23828 11.7585 8.23828 10.5651 8.97979 9.82354C9.72131 9.08203 10.9147 9.08203 13.3016 9.08203H20.0528C22.4397 9.08203 23.6331 9.08203 24.3746 9.82354C25.0711 10.52 25.1134 11.6152 25.116 13.7234",
    stroke: "#007E8C",
    strokeWidth: 1.03108,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0527 18.3649V21.7404C20.0527 22.9339 20.0527 23.5306 20.4235 23.9014C20.7943 24.2721 21.391 24.2721 22.5844 24.2721C23.7778 24.2721 24.3746 24.2721 24.7454 23.9014C25.1161 23.5306 25.1161 22.9339 25.1161 21.7404V18.3649C25.1161 17.1714 25.1161 16.5747 24.7454 16.2039C24.3746 15.8332 23.7778 15.8332 22.5844 15.8332C21.391 15.8332 20.7943 15.8332 20.4235 16.2039C20.0527 16.5747 20.0527 17.1714 20.0527 18.3649Z",
    stroke: "#007E8C",
    strokeWidth: 1.03108,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9895 24.2721H13.3018M14.9895 24.2721C15.6886 24.2721 16.2554 23.7054 16.2554 23.0063V20.8965H16.6773M14.9895 24.2721H17.0993V20.8965H16.6773M16.6773 20.8965V24.2721",
    stroke: "#007E8C",
    strokeWidth: 1.03108,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm2);
export default __webpack_public_path__ + "static/media/form-2.ed212b66e4ec2883d8aa9418901f6fa0.svg";
export { ForwardRef as ReactComponent };